import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createBlock(_component_BaseButton, {
    "product-id": _ctx.productId,
    "product-type": _ctx.productType,
    "cart-route": _ctx.linkToCart,
    "checkout-route": _ctx.linkToCheckout,
    "basket-button-title": _ctx.basketButtonTitle,
    "order-button-title": _ctx.orderButtonTitle,
    "with-counter": _ctx.withCounter
  }, null, 8, ["product-id", "product-type", "cart-route", "checkout-route", "basket-button-title", "order-button-title", "with-counter"]))
}